module.exports = __webpack_public_path__ + "static/feature-54bf66a93de7cbdcf6ac0291600ee7da.png";